const editInvoiceDialogConstantsEN = {
  editInvoiceDialogHeader: 'Edit Slip',
  editInvoiceDialogSaveButton: 'Update Slip',
  editInvoicePlaceholder: 'Status',
};

export default editInvoiceDialogConstantsEN;
